import DurationTimer from '../utils/DurationTimer';
import MessageBus from '@restore/messagebus';
export default class AttributionDurationService {
  private durationTimer: DurationTimer;
  private messageBus: MessageBus;

  constructor() {
    this.durationTimer = new DurationTimer();
    this.messageBus = new MessageBus(false);

    this.messageBus.subscribe('startTimer', () => {
      this.durationTimer.start();
    });

    this.messageBus.subscribe('pauseTimer', () => {
      this.durationTimer.pause();
    });

    type timerRequestPayload = { requestID: number };

    this.messageBus.subscribe('stopTimer', (payload) => {
      const { requestID } = payload as timerRequestPayload;
      this.messageBus.respond('stopTimer', requestID, this.durationTimer.stop());
    });

    this.messageBus.subscribe('getDuration', (payload) => {
      const { requestID } = payload as timerRequestPayload;
      this.messageBus.respond('getDuration', requestID, this.durationTimer.getTime());
    });
  }

  cleanup() {
    this.messageBus.unsubscribe('startTimer');
    this.messageBus.unsubscribe('pauseTimer');
    this.messageBus.unsubscribe('stopTimer');
    this.messageBus.unsubscribe('getDuration');
  }
}
